import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Component, Fragment } from "react";
import { initLenis, scrollToTopImmediate } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WhyDholera from "@/components/WhyDholera";
import About from "@/components/About";
import Properties from "@/components/Properties";
import Projects from "@/components/Projects";
import LocationSection from "@/components/LocationSection";
import InvestmentGuide from "@/components/InvestmentGuide";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingCTAs from "@/components/FloatingCTAs";
import ChatWidget from "@/components/ChatWidget";
import LegalPage from "@/pages/LegalPage";
import WriterPage from "@/pages/WriterPage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-paper p-8 text-center">
          <div>
            <p className="font-serif text-3xl text-navy">Something went wrong</p>
            <p className="mt-3 text-body">Please refresh the page. For enquiries, call +91 79885 00427.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTopImmediate();
  }, [pathname]);
  return null;
}

function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <WhyDholera />
        <About />
        <Properties />
        <Projects />
        <LocationSection />
        <InvestmentGuide />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingCTAs />
      <ChatWidget />
    </>
  );
}

export default function App() {
  useEffect(() => {
    initLenis();
  }, []);
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <RouteEffects />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<LegalPage kind="privacy" />} />
            <Route path="/terms" element={<LegalPage kind="terms" />} />
            <Route path="/disclaimer" element={<LegalPage kind="disclaimer" />} />
            <Route path="/writer" element={<WriterPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
        <div className="grain" aria-hidden="true" />
      </ErrorBoundary>
    </div>
  );
}
